<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'FAQ',

    metaInfo: { title: 'Questions fréquentes' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'faq',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'faq',
      },
    },
  }
</script>
